import { Card, Col, Row } from "antd";
import React from "react";
import { RiAddLine } from "react-icons/ri";

import "./ApplicationFees.css";

function ApplicationFees() {
  return (
    <div className="application-fees">
      <Card
        title="Application Fees"
        extra={
          <button className="icon-text-btn">
            <RiAddLine size={18} />
            <span>Enter Application Fee</span>
          </button>
        }
      >
        <Card
          extra={
            <p className="onclick-text extra-btns">
              <span>Refund</span>{" "}
              <span>Print</span>
            </p>
          }
        >
          <Row>
            <Col span={24}>
              <p>
                Received{" "}
                <span className="onclick-text">$30.00 on 02/08/2021</span> via
                Credit Card. <span className="paid-text">Paid</span>{" "}
              </p>
            </Col>
          </Row>
        </Card>
      </Card>
    </div>
  );
}

export default ApplicationFees;
